export const DEFAULT_ALL_TYPES_CRYPTOGRAPHY = ['encrypt', 'decrypt'];
export const DEFAULT_TYPE_ENCRYPT_CRYPTOGRAPHY = 'encrypt';
export const DEFAULT_TYPE_DECRYPT_CRYPTOHRAPHY = 'decrypt';
